module.exports = __webpack_public_path__ + "static/media/NewWindow.3c6b3047.svg";